'use client';

import type { ReactNode } from 'react';
import * as React from 'react';
import { flags as confidenceExperiments } from '@mentimeter/flags/confidence/experiments';
import { DevelopmentToolsSetup } from './DevelopmentToolsSetup';

export function WwwDevelopmentToolsSetup({
  isAuthorizedToInteractWithDevelopmentTools,
  children,
}: {
  isAuthorizedToInteractWithDevelopmentTools: boolean;
  children: ReactNode;
}) {
  return (
    <DevelopmentToolsSetup
      confidenceExperiments={confidenceExperiments}
      isAuthorizedToInteractWithDevelopmentTools={
        isAuthorizedToInteractWithDevelopmentTools
      }
    >
      {children}
    </DevelopmentToolsSetup>
  );
}
